import { useAuth0 } from "@auth0/auth0-react";
import React, { createContext, useMemo } from "react";

import { EnvVar } from "@/env";

import { ScenarioBuilderClient } from "../client/scenarioClient";

type ScenarioBuilderContextType = {
  scenarioBuilderClient: ScenarioBuilderClient;
};

export const ScenarioBuilderContext = createContext<ScenarioBuilderContextType | null>(null);

interface ScenarioBuilderContextProviderProps {
  children: React.ReactNode;
}

export const ScenarioBuilderContextProvider: React.FC<ScenarioBuilderContextProviderProps> = ({
  children,
}) => {
  const { getAccessTokenSilently } = useAuth0();

  const scenarioBuilderClient = useMemo(() => {
    const client = new ScenarioBuilderClient();

    const getAccessToken = async () => {
      try {
        const tokenResponse = await getAccessTokenSilently({
          cacheMode: "on",
          authorizationParams: {
            audience: EnvVar.auth0Audience,
            scope: "profile email read:current_user",
          },
          detailedResponse: true,
        });
        return tokenResponse.id_token || "";
      } catch (error) {
        console.error("Failed to get access token:", error);
        throw error;
      }
    };

    const handleUnauthorized = () => {
      console.warn("Unauthorized API call, logging out");
    };

    client.setupAuthInterceptor(getAccessToken, handleUnauthorized);
    return client;
  }, [getAccessTokenSilently]);

  return (
    <ScenarioBuilderContext.Provider
      value={{
        scenarioBuilderClient,
      }}
    >
      {children}
    </ScenarioBuilderContext.Provider>
  );
};
